<section class="db-single-page-generation-step">
    <div class="create-ai-image-wrap">
      <div class="create-ai-image-1">
        <div class="create-ai-image">
          <img src="assets/images/ai/onboarding/ai-informative-light.svg" alt="">
        </div>
      </div>
      <div class="create-ai-image-2">
        <div class="create-ai-image">
          <img src="assets/images/ai/onboarding/ai-informative-light-full.svg" alt="">
        </div>
      </div>
    </div>

  <div class="db-right-side">
    <db-outline-generation-finalize [steps]="generationSteps"
                                    [stepTime]="10000"
                                    [singlePage]="true">
    </db-outline-generation-finalize>
  </div>
</section>

